import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LeaderboardView from './LeaderboardView';
import SourceDialog from './SourceDialog';
import ItchView from './ItchView';
import ItchSourceDialog from './ItchSourceDialog';

const hostOf = (url) => {
  try { return new URL(url).host; } catch { return url; }
};

// Dashboard templates. Each one picks its data source with `SourceDialog`,
// names it with `sourceLabel`, and renders the server's data with `View`.
// The server only knows the ids (see routes/dashboards.js).
export const TEMPLATES = [
  {
    id: 'leaderboard',
    name: 'Leader Board',
    description: 'Ranked players from a JSON endpoint: leader, median, gaps and breakdowns.',
    Icon: EmojiEventsIcon,
    View: LeaderboardView,
    SourceDialog,
    sourceLabel: (s) => s.label || hostOf(s.url),
    sourceHint: s => s.url,
    emptyText: 'Connect a JSON endpoint — fields are detected automatically.',
    addLabel: 'Add data source',
  },
  {
    id: 'itch',
    name: 'itch.io',
    description: 'Views, downloads, purchases and earnings of an itch.io game, with daily history.',
    Icon: StorefrontOutlinedIcon,
    View: ItchView,
    SourceDialog: ItchSourceDialog,
    sourceLabel: (s) => s.title || `itch.io game ${s.gameId}`,
    sourceHint: (s) => `itch.io game #${s.gameId}`,
    emptyText: 'Pick one of the studio’s itch.io games.',
    addLabel: 'Connect itch.io game',
  },
];

export const getTemplate = (id) => TEMPLATES.find((t) => t.id === id);
